module.exports = __webpack_public_path__ + "media/images/gallery/constellations/aquila/aql_names-72cae2829c13e5e8427bc5bf160f2007.gif";